import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { Files, FileUploadType } from "./Files";
import { FileItem } from "./FileItem";
import { WithModal, withModal } from "../Modal/withModal";

interface AddProps extends WithTranslation, WithModal {
  value?: API_FileDataEntity[];
  onChange?: (v: Array<API_FileDataEntity>) => [];
  fileUploadType: FileUploadType;
  minimumAccessLevel?: API_DOCUMENTS_MINACCESSLEVEL;
  isRadioSelection?: boolean;
  buttonTitle?: string;
  buttonStyle?: React.CSSProperties;
  buttonRenderer?: (f: () => void) => React.ReactNode;
}

export const AddFiles = withTranslation(I18N_NS.PROJECT)(
  withModal(
    class extends React.Component<AddProps> {
      showFilesModal = () => {
        this.props.showModal(Files, {
          modalProps: {
            footer: null,
            destroyOnHidden: true,
            maskClosable: false,
            style: { maxWidth: "680px" },
            zIndex: 1800,
            width: "100%",
            wrapClassName: "email-search-modal",
          },
          componentProps: {
            initialValue: this.props.value,
            isRadioSelection: this.props.isRadioSelection,
            onChange: this.handleChange,
            fileUploadType: this.props.fileUploadType || "ALL",
            minimumAccessLevel: this.props.minimumAccessLevel,
          },
        });
      };

      handleChange = (files: Array<API_FileDataEntity>) => {
        const { onChange } = this.props;
        if (typeof onChange !== "function") {
          console.warn("onChange handler is not set up!");
          return;
        }
        onChange(files);
      };

      handleRemove = (id: number) => {
        const { value, onChange } = this.props;
        const newValue = value.filter((item) => item.id !== id);
        onChange(newValue);
      };

      render() {
        const { t } = this.props;
        return (
          <>
            {this.props.value &&
              this.props.value.map((item) => <FileItem file={item} key={item.id} onRemove={this.handleRemove} />)}
            {this.props.buttonRenderer ? (
              this.props.buttonRenderer(this.showFilesModal)
            ) : (
              <>
                <a onClick={this.showFilesModal} style={this.props.buttonStyle}>
                  {t(this.props.buttonTitle ? this.props.buttonTitle : "Add files")}
                </a>
              </>
            )}
          </>
        );
      }
    }
  )
);
